// eslint-disable-next-line
import Symbol_observable from 'symbol-observable';

import React from 'react';
import ReactDOM from 'react-dom';

//import whyDidYouUpdate from '@welldone-software/why-did-you-render/dist/no-classes-transpile/umd/whyDidYouRender.min.js'

import App from './StandaloneApp';

//eslint-disable-next-line
//@ts-ignore
/*if(DEVMODE === 'DEVELOPMENT') {
    whyDidYouUpdate(React);
}*/

ReactDOM.render(<App />, document.getElementById('ee-root'));

export default {};
